// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".who[data-v-81ad18a0] {\n  margin-top: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
